
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["stroke-current",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32","class":"stroke-current"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.08 18.398 1 13.443l10.08 14.87L31 3z","vector-effect":"non-scaling-stroke"}})])
          )
        }
      }
    